var map = {
	"./de/general5/slide3.svg": 590080,
	"./en/general5/slide3.svg": 777396,
	"./es/general5/slide3.svg": 202553,
	"./fr/general5/slide3.svg": 134449,
	"./nl/general5/slide3.svg": 816279,
	"./pt/general5/slide3.svg": 816149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 979790;